/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CategoriesResponse } from '../model';
// @ts-ignore
import { CategoryDto } from '../model';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { UpdateCategoryRequest } from '../model';
/**
 * CategoryApi - axios parameter creator
 * @export
 */
export const CategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation creates a new category. The request can accept multiple categories, and this response will contain new categories, not entire list.
         * @summary Creates a new category
         * @param {CategoryDto} categoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (categoryDto: CategoryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryDto' is not null or undefined
            assertParamExists('createCategory', 'categoryDto', categoryDto)
            const localVarPath = `/v1/entity/organization/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = categoryDto

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves categories list with belonging products.
         * @summary Gets categories list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deletes a specified category. If there is any organizations that using this specified category, this request will return an error.
         * @summary Removes a specified category
         * @param {string} id Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCategory: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCategory', 'id', id)
            const localVarPath = `/v1/entity/organization/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation updates a specified category.
         * @summary Updates a specified category
         * @param {string} id Category ID
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory: async (id: string, updateCategoryRequest: UpdateCategoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCategory', 'id', id)
            // verify required parameter 'updateCategoryRequest' is not null or undefined
            assertParamExists('updateCategory', 'updateCategoryRequest', updateCategoryRequest)
            const localVarPath = `/v1/entity/organization/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateCategoryRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryApi - functional programming interface
 * @export
 */
export const CategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * This operation creates a new category. The request can accept multiple categories, and this response will contain new categories, not entire list.
         * @summary Creates a new category
         * @param {CategoryDto} categoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(categoryDto: CategoryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(categoryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves categories list with belonging products.
         * @summary Gets categories list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation deletes a specified category. If there is any organizations that using this specified category, this request will return an error.
         * @summary Removes a specified category
         * @param {string} id Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCategory(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCategory(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation updates a specified category.
         * @summary Updates a specified category
         * @param {string} id Category ID
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(id, updateCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CategoryApi - factory interface
 * @export
 */
export const CategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryApiFp(configuration)
    return {
        /**
         * This operation creates a new category. The request can accept multiple categories, and this response will contain new categories, not entire list.
         * @summary Creates a new category
         * @param {CategoryDto} categoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(categoryDto: CategoryDto, options?: any): AxiosPromise<CategoriesResponse> {
            return localVarFp.createCategory(categoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves categories list with belonging products.
         * @summary Gets categories list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryList(options?: any): AxiosPromise<CategoriesResponse> {
            return localVarFp.getCategoryList(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deletes a specified category. If there is any organizations that using this specified category, this request will return an error.
         * @summary Removes a specified category
         * @param {string} id Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCategory(id: string, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.removeCategory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation updates a specified category.
         * @summary Updates a specified category
         * @param {string} id Category ID
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.updateCategory(id, updateCategoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoryApi - interface
 * @export
 * @interface CategoryApi
 */
export interface CategoryApiInterface {
    /**
     * This operation creates a new category. The request can accept multiple categories, and this response will contain new categories, not entire list.
     * @summary Creates a new category
     * @param {CategoryDto} categoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApiInterface
     */
    createCategory(categoryDto: CategoryDto, options?: AxiosRequestConfig): AxiosPromise<CategoriesResponse>;

    /**
     * This retrieves categories list with belonging products.
     * @summary Gets categories list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApiInterface
     */
    getCategoryList(options?: AxiosRequestConfig): AxiosPromise<CategoriesResponse>;

    /**
     * This operation deletes a specified category. If there is any organizations that using this specified category, this request will return an error.
     * @summary Removes a specified category
     * @param {string} id Category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApiInterface
     */
    removeCategory(id: string, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation updates a specified category.
     * @summary Updates a specified category
     * @param {string} id Category ID
     * @param {UpdateCategoryRequest} updateCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApiInterface
     */
    updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
export class CategoryApi extends BaseAPI implements CategoryApiInterface {
    /**
     * This operation creates a new category. The request can accept multiple categories, and this response will contain new categories, not entire list.
     * @summary Creates a new category
     * @param {CategoryDto} categoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public createCategory(categoryDto: CategoryDto, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).createCategory(categoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves categories list with belonging products.
     * @summary Gets categories list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategoryList(options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategoryList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deletes a specified category. If there is any organizations that using this specified category, this request will return an error.
     * @summary Removes a specified category
     * @param {string} id Category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public removeCategory(id: string, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).removeCategory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation updates a specified category.
     * @summary Updates a specified category
     * @param {string} id Category ID
     * @param {UpdateCategoryRequest} updateCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: AxiosRequestConfig) {
        return CategoryApiFp(this.configuration).updateCategory(id, updateCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
